import React__default from 'react';
import { Price } from '@grandvisionhq/common';
import { Text } from '@grandvisionhq/elements';

const MonthlyPrice = ({ currency , price , labels  })=>/*#__PURE__*/ React__default.createElement("div", {
        className: "contact-lens-configurator__monthly-price"
    }, /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, /*#__PURE__*/ React__default.createElement(Price, {
        value: price.centAmount,
        currency: currency,
        className: "contact-lens-configurator__pack-size-price"
    }), ' / ', /*#__PURE__*/ React__default.createElement(Text, {
        variant: "caption",
        component: "span"
    }, labels.perMonth)))
;
var MonthlyPrice$1 = MonthlyPrice;

export { MonthlyPrice$1 as default };
//# sourceMappingURL=MonthlyPrice.js.map
